import type { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: ${({
  theme
}) => theme.color.bg1};
`;
const IconImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
`;
const IconImage = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  ${({
  theme
}) => theme.isRtl && `transform: scaleX(-1);`}
`;
const Text = styled.span`
  font-size: 13px;
  font-weight: 700;
  line-height: 16px;
  color: ${({
  theme
}) => theme.color.primary1};
`;
interface WebOnlyDiscountLabelProps {
  className?: string;
  iconUrl?: string;
}
const WebOnlyDiscountLabel = ({
  children,
  className,
  iconUrl
}: PropsWithChildren<WebOnlyDiscountLabelProps>) => {
  return <Container className={className} data-sentry-element="Container" data-sentry-component="WebOnlyDiscountLabel" data-sentry-source-file="WebOnlyDiscountLabel.tsx">
      {iconUrl && <IconImageContainer>
          <IconImage src={iconUrl} alt='' />
        </IconImageContainer>}
      <Text data-sentry-element="Text" data-sentry-source-file="WebOnlyDiscountLabel.tsx">{children}</Text>
    </Container>;
};
export default WebOnlyDiscountLabel;